<section class="close">
  <mat-icon (click)="close()">close</mat-icon>
</section>
<ul class="menu">
  <li class="header">{{ appStringAPI.getAppString('settings.gambling.button') }}</li>
  <li class="menu-item">
    <div class="menu-header">{{ appStringAPI.getAppString('settings.gambling.odds.21.question') }}</div>
    <div class="menu-section">
      <div
        class="gambling-menu-option"
        (click)="postGamblingDisplay(odds_preferences, true)"
        >
        <div>{{ appStringAPI.getAppString('settings.gambling.odds.21.question.yes') }}</div>
        @if (legal_age) {
          <mat-icon class="check">check</mat-icon>
        }
      </div>
      <div
        class="gambling-menu-option"
        (click)="postGamblingDisplay(odds_preferences, false)"
        >
        <div>{{ appStringAPI.getAppString('settings.gambling.odds.21.question.no') }}</div>
        @if (!legal_age) {
          <mat-icon class="check">check</mat-icon>
        }
      </div>
    </div>
  </li>
  @if (legal_age) {
    <li class="menu-item">
      <div class="menu-header">{{ appStringAPI.getAppString('settings.gambling.odds.display.title') }}</div>
      <div class="menu-section">
        @for (display of gambling_displays; track display) {
          <div
            class="gambling-menu-option"
            (click)="postGamblingDisplay(display, legal_age)"
            >
            <div>{{ appStringAPI.getAppString('settings.gambling.odds.display.' + display) }}</div>
            @if (odds_preferences === display) {
              <mat-icon class="check">check</mat-icon>
            }
          </div>
        }
      </div>
    </li>
  }
</ul>